import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ChangeEventHandler, FC } from 'react';

import { IcChechActiveIcon } from '@gem/icons';
import { IconView } from '@gem/ui-kit';

import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import styles from './MessageSelect.styles.m.css';

interface IMessageSelectProps {
  className?: string;
  message: ChatMessage;
  onMessageSelect: ChangeEventHandler<HTMLInputElement>;
  isChannel?: boolean;
  labelClassName?: string;
}

export const MessageSelect: FC<IMessageSelectProps> = observer((props) => {
  const { message, onMessageSelect, isChannel = true, labelClassName, className } = props;
  return (
    <div className={classNames(styles.select, className, { [styles.isChannel]: isChannel })}>
      {message.showSelect && (
        <label className={classNames(styles.checkbox, labelClassName)}>
          <input
            type="checkbox"
            checked={message.isSelected}
            onChange={onMessageSelect}
            className={styles.input}
          />
          {message.isSelected ? (
            <div className={styles.activeContainer}>
              <IconView
                Icon={IcChechActiveIcon}
                className={styles.active}
              />
              <span className={styles.activeBorder} />
            </div>
          ) : (
            <span className={styles.inactive} />
          )}
        </label>
      )}
    </div>
  );
});
